/*  EDIT USER TYPE */
export const SET_USER_FOR_EDIT: string = "SET_USER_FOR_EDIT";
export const CLEAR_USER: string = "CLEAR_USER";
